var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import get from 'lodash/get';
import { createSelector } from '@reduxjs/toolkit';
export var selectConfigState = function (state) { return state.config; };
export var selectConfigAPIKey = createSelector(selectConfigState, function (config) { return config.apiKey; });
export var selectConfigBaseURL = createSelector(selectConfigState, function (config) { return config.baseUrl; });
export var selectConfigVersion = createSelector(selectConfigState, function (config) { return config.version; });
export var selectExternalData = createSelector(selectConfigState, function (config) { return get(config, 'external.data'); });
export var selectHostBookables = createSelector(selectConfigState, function (config) {
    return get(config, 'external.hostBookables') || {};
});
// Effective bookables filters: internal writes first, host-provided filters
// (window.conversionalIntegration / window.conversionalWidget / URL query
// string) always on top — they persist
// until the host explicitly clears them via `data.bookables = null`.
// An internal list may still narrow a host list (e.g. a journey's service type
// cards within the host's allowed types), but never widen or replace it.
export var selectExternalDataBookables = createSelector(selectExternalData, selectHostBookables, function (externalData, hostBookables) {
    var internal = get(externalData, 'bookables') || {};
    var merged = __assign(__assign({}, internal), hostBookables);
    Object.keys(hostBookables).forEach(function (key) {
        if (!Array.isArray(hostBookables[key]) || !Array.isArray(internal[key]))
            return;
        var narrowed = internal[key].filter(function (id) { return hostBookables[key].includes(id); });
        if (narrowed.length)
            merged[key] = narrowed;
    });
    return merged;
});
export var selectQueryParams = createSelector(selectConfigState, function (config) { return get(config, 'external.hostQueryParams', {}); });
export var selectExternalProcess = createSelector(selectConfigState, function (config) { return get(config, 'external.process'); });
export var selectProcessPathNameInExternal = createSelector(selectConfigState, function (config) { return get(config, 'external.selectedProcessPathName'); });
export var selectHostQueryParams = createSelector(selectConfigState, function (config) { return get(config, 'external.hostQueryParams', {}); });
export var selectHostUrl = createSelector(selectConfigState, function (config) { return get(config, 'external.hostUrl'); });
export var selectHostReferrer = createSelector(selectConfigState, function (config) { return get(config, 'external.hostReferrer'); });
export var selectThemeConfig = createSelector(selectConfigState, function (config) { return (config === null || config === void 0 ? void 0 : config.theme) || {}; });
export var abTestSelector = function (state) {
    return state.config.abTest || undefined;
};
export var initialJourneyId = function (state) {
    return state.config.journeyId;
};
export var selectBookingLinkData = createSelector(selectConfigState, function (config) { var _a; return (_a = config.bookingLink) === null || _a === void 0 ? void 0 : _a.data; });
export var selectBookingLinkLoading = createSelector(selectConfigState, function (config) { var _a; return (_a = config.bookingLink) === null || _a === void 0 ? void 0 : _a.loading; });
export var selectBookingLinkError = createSelector(selectConfigState, function (config) { var _a; return (_a = config.bookingLink) === null || _a === void 0 ? void 0 : _a.error; });
export var selectBookingLinkBranchServices = createSelector(selectBookingLinkData, function (data) { return (data === null || data === void 0 ? void 0 : data.branch_services) || []; });
export var selectBookingLinkServiceTypes = createSelector(selectBookingLinkBranchServices, function (branchServices) {
    var serviceTypesMap = new Map();
    branchServices.forEach(function (branchService) {
        if (branchService.service_type && branchService.service_type.uuid) {
            serviceTypesMap.set(branchService.service_type.uuid, branchService.service_type);
        }
    });
    return Array.from(serviceTypesMap.values());
});
